import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CartRepository from 'src/features/cart/data/CartRepository';
import { diContainer } from 'src/inversify.config';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { useEffect } from 'react';

const cartRepository = diContainer.get<CartRepository>(CartRepository);

const useCartQuery = () => {
  const { session, user, setSession, setTokenExpired } = useAuthContext();

  const cartQuery = useQuery({
    queryKey: ['cart', { userId: user?.pk, accessToken: session?.accessToken }],
    queryFn: () =>
      cartRepository.getCartByUserId({
        userId: user?.pk as number,
        accessToken: session?.accessToken as string,
      }),
    enabled: !!user?.pk && !!session?.accessToken,
    retry: 0,
  });

  useEffect(() => {
    if (cartQuery.data?.pk) {
      setSession &&
        session &&
        setSession(
          session && {
            ...session,
            user: { ...session.user, active_cart: cartQuery.data.pk },
          }
        );
    }
  }, [cartQuery.data, setSession, cartQuery.isError]);

  useEffect(() => {
    if (cartQuery.isError && session && !cartQuery.isLoading) {
      const error = cartQuery.error as AxiosError | undefined;
      if (error?.response?.status === 403) {
        setTokenExpired(true);
      }
    }
  }, [cartQuery, session, setTokenExpired]);

  return cartQuery;
};

export default useCartQuery;
